import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { PatchRequestType, UserPreferences } from '../types';

const { axiosService } = useAxios(2);

export const getUserPreferences = async (): Promise<UserPreferences | null> => {
  try {
    const response: AxiosResponse = await axiosService.get('/settings/preferences');
    return response.data;
  } catch (err) {
    return null;
  }
};

export const patchPreferences = async (
  id: number,
  patches: PatchRequestType[],
): Promise<UserPreferences | null> => {
  try {
    const response: AxiosResponse = await axiosService.patch(
      `/settings/preferences/${id}`, patches,
    );
    return response.data;
  } catch (err) {
    return null;
  }
};
